import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { sanitizeHtml } from '../../helpers/sanitizeHtml';
import { IFaq } from '../../models/FaqsInterface';
import './Faq.scss';
import { useEffect, useState } from 'react';

interface Props extends IFaq {
  defaultExpanded?: boolean;
  onExpandToggle?: (expand: boolean) => void;
  selected: boolean;
}

const Faq = (props: Props) => {
  const {
    question,
    answer: ComponentToRender,
    defaultExpanded,
    onExpandToggle,
    id = '',
    selected
  } = props;
  const [isExpand, setIsExpand] = useState(false);

  useEffect(() => {
    let observer: IntersectionObserver | null = null;
    if (selected) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('selected-faq');
            observer?.disconnect();
          }
        });
      });
      observer.observe(
        document.getElementById(id)?.children[0] as HTMLDivElement
      );
    }
    return () => observer?.disconnect();
  }, [selected, id]);

  useEffect(
    () => setIsExpand(defaultExpanded || selected || false),
    [defaultExpanded, selected]
  );
  const handleOnChange = () => {
    onExpandToggle && onExpandToggle(!isExpand);
    setIsExpand(!isExpand);
  };

  return (
    <div className="faq-container" id={id}>
      <Accordion expanded={isExpand} onChange={handleOnChange}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(question) }}></p>
        </AccordionSummary>
        <AccordionDetails>
          {typeof props.answer === 'string' ? (
            <div
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.answer) }}
              className="faq-answers"
            ></div>
          ) : (
            <ComponentToRender />
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Faq;
